import PubSub from "underpub-js";
import gsap from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

var LabelUnderlined = function (options) {

  this.options = {
    $el: false,
    baseClass: 'atom-LabelUnderlined',
  };

  $.extend(true, this.options, options);

};

LabelUnderlined.prototype.init = function () {

  var self = this;
  self.$icon = self.options.$el.find(`.${self.options.baseClass}__icon`);
  self.$iconSVG = self.$icon.find("svg #line");

  gsap.set(self.$icon, {
    visibility: "hidden"
  })

  PubSub.subscribe('loaded', () => self.initAnimation());
};

LabelUnderlined.prototype.initAnimation = function () {
  const self = this;

  gsap.timeline({
      delay: .1,
      scrollTrigger: {
        trigger: self.options.$el[0],
        start: "bottom 95%"
      }
    })
    .set(self.$icon, {
      visibility: "visible"
    })
    .fromTo(self.$iconSVG, {
      drawSVG: "0%"
    }, {
      drawSVG: "100%",
      ease: "expo.inout",
      duration: .7,
    })
}

export default LabelUnderlined;